import { roleGuarded } from '@/components/shell/RoleState';
import { HandoffTab } from '@/features/ai/HandoffTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/ai/handoff')({
  staticData: { roles: ['owner'] },
  component: roleGuarded(HandoffTab),
});
